import { create } from "zustand";

export type ColorType = "primary" | "gray" | "blue" | "red" | "green";

interface AlertState {
  message: string;
  color: ColorType;
  show: boolean;
  setAlert: (message: string, color: ColorType) => void;
  hideAlert: () => void;
};

export const useAlertStore = create<AlertState>((set) => ({
  message: "",
  color: "primary",
  show: false,
  setAlert: (message, color) => set({ message, color, show: true }),
  hideAlert: () => set({ show: false }),
}));
